import type {
	CustomItem,
	DropPlatformType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropPlatform = (
	item: Item | CustomItem
): item is DropPlatformType => {
	return !!(item && item.__typename === 'Drop_Platform');
};
